import dynamic from "next/dynamic";

const Banner = dynamic(
	() => import("components/banner/banner"),
);

const Desktop = (props) => {

	const prop = props;

	return (
		<>
			<div className="ads-container">
				<Banner
					component_id="horizontal"
					name="horizontal"
					placeholder="horizontal"
					is_mobile={prop.isMobile}
					class_name="horizontal-home"
				/>
				<style jsx>
					{`
                    .ads-container {
                        display: flex;
                        align-content: center;
                        justify-content: center;
                    }
                `}
				</style>
			</div>
			<div className="container-fake-free">
				<div className="child-container-fake-free">
					<div className="illustration-section">
						<img className="ic-review" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/review-fake-free.svg" alt="illustration" />
						<img className="ic-illustration" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/illustration-fake-free.svg" alt="illustration" />
					</div>
					<div className="description-section">
						<div className="title-section">
							<p className="title-fake-free">Keep your beauty review</p>
							<img className="image-fake-free" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/stamp-fake-free.png" alt="illustration" />
						</div>
						<p className="description-fake-free">with authentic & honest reviews from your personal experience</p>
						<a href={`${process.env.NEXT_PUBLIC_ROOT_HOME}/terms-and-conditions`} className="term-and-condition">
							READ TERMS & CONDITION
							<img className="ic-next" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/ic-next.svg" alt="illustration" />

						</a>
					</div>

				</div>

				<style jsx>
					{`
					.container-fake-free{
                        background-image: url("https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/background-fake-free.svg");
						height: 248px;
                        background-repeat: no-repeat;
                        background-size: cover;
                        padding-top:32px;
                        margin: 56px 0;
                    }
                    .ic-review{
                        position: absolute;    
                        left: 15.5%;

                    }
                    .ic-illustration{
                        position: absolute;
                    }

                    .illustration-section{
                        position: relative;
                        z-index: 1;
                    }

                    .description-section{
                        background: white;
                        left: 38%;
                        position: relative;
                        box-shadow: 0px 2px 8px rgb(0 0 0 / 10%);
                        border-radius: 6px;
                        padding: 8px 30px 30px 56px;
                        width: 670px;
                        top: 20px;
                    }
                    .title-section{
                        display: flex;
                        align-items: center;
                        align-content: center;
                    }
                    .title-fake-free{
                        font-family: 'Merriweather';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 32px;
                        line-height: 40px;
                        color: #DC274F;
                        margin:0;
                    }
                    .description-fake-free{
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 300;
                        font-size: 24px;
                        line-height: 28px;
                        color: #323942;
                        margin-top: 2px;
                        margin-bottom: 32px;
                    }
                    .term-and-condition{
                        font-family: 'Poppins';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 20px;
                        line-height: 28px;
                        text-align: right;
                        text-transform: capitalize;
                        color: #000000;
                        padding-bottom: 8px;
                        border-bottom: 1px solid black;
                    }
                    .ic-next{
                        margin-left: 14px;
                    }
                    .child-container-fake-free{
                        max-width:1232px;
                        margin: 0 auto;
                    }
                    .image-fake-free {
                        height: 65px;
                    }

                    @media (max-width: 1280px){
                        .container-fake-free{
                            padding-top: 22px;
                        }
                        .child-container-fake-free{
                            max-width:1100px;
                            margin: 0 auto;
                        }
                        .ic-review{
                            top: 25px;
                        }
                        .ic-illustration{
                            max-width:470px;
                            margin-top: 21px;
                        }
                        .description-section{
                            max-width: 550px;
                            top: 10px;
                        }
                    }
                    @media (max-width: 1080px){
                        .container-fake-free{
                            padding-bottom: 8px;
                        }
                        .ic-illustration{
                            max-width:450px;
                            margin-top: 41px;
                        }
                        .ic-review{
                            top: 35px;
                        }
                        .description-section{
                            max-width: 500px;
                            top: 10px;
                        }
                        .title-fake-free{
                            font-size: 27px;
                        }
                        .description-fake-free{
                            font-size: 20px;
                        }
                    }
				`}
				</style>
			</div>
		</>
	);

};

export default Desktop;
